import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { createFileRoute } from "@tanstack/react-router";
import { SavedSearchesList } from "@/features/saved/SavedSearchesList";

function SavedIndexPage() {
  return (
    <Container maxWidth="lg" disableGutters>
      <Typography variant="h4" component="h1" gutterBottom>
        Saved Searches
      </Typography>
      <SavedSearchesList />
    </Container>
  );
}

export const Route = createFileRoute("/_authed/saved/")({
  component: SavedIndexPage,
});
